import request from '../common/request.js';

//获取标签批次
export function GetLableBatchInfo(payload) {
    return request.post('/Plat/Label/GetLableBatchInfo', payload);
}

//新增标签批次
export function AddLableBatch(payload) {
    return request.post('/Plat/Label/AddLableBatch', payload);
}

//更新标签批次
export function UpdateLableBatch(payload) {
    return request.post('/Plat/Label/UpdateLableBatch', payload);
}

//删除标签批次
export function DelLableBatch(payload) {
    return request.post('/Plat/Label/DelLableBatch', payload);
}

//获取标签详情
export function GetLableDetailInfo(payload) {
    return request.post('/Plat/Label/GetLableDetailInfo', payload);
}

//标签数据导入
export function UploadLableDetail(payload) {
    return request.post('/Plat/Label/UploadLableDetail', payload);
}

//编辑标签详情
export function UpdateLableDetail(payload) {
    return request.post('/Plat/Label/UpdateLableDetail', payload);
}

//删除标签详情
export function DelLableDetail(payload) {
    return request.post('/Plat/Label/DelLableDetail', payload);
}
